module.exports = __webpack_public_path__ + "img/clock_in.54277959.png";